export default "__VITE_ASSET__BOT7x5cy__"